import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarMenuItem } from '../../../core/models/taskboard.models';

@Component({
  selector: 'app-sidebar-tooltip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="sidebar-tooltip"
         [style.left]="position.left + 'px'"
         [style.top]="position.top + 'px'"
         (mouseenter)="onTooltipEnter()"
         (mouseleave)="onTooltipLeave()">
      <div class="tooltip-submenu">
        @for (sub of hoveredItem?.children; track sub.label) {
          @if (sub.children?.length) {
            <div class="tooltip-subgroup">
              <div class="tooltip-subheading"
                   [class.disabled]="sub.disabled"
                   [class.tooltip-subheading--clickable]="sub.disabled && sub.comingSoon"
                   (click)="onSubgroupHeadingClick(sub)">
                <span class="tooltip-subheading-label">{{ sub.label }}</span>
                @if (sub.disabled && sub.comingSoon) {
                  <span class="sidebar-coming-soon-chip">Coming Soon</span>
                }
              </div>
              @for (nested of sub.children; track nested.label) {
                <a class="tooltip-subitem tooltip-subitem-nested"
                   [attr.href]="resolveHref(nested)"
                   [attr.target]="anchorTarget(nested)"
                   [attr.rel]="anchorRel(nested)"
                   [class.active]="isSubItemActive(nested)"
                   [class.disabled]="nested.disabled"
                   [class.pointer-events-none]="nested.disabled && !nested.comingSoon"
                   (click)="onAnchorClick($event, nested)">
                  <span class="tooltip-sub-label-row">
                <span class="tooltip-sub-label" [class.disabled]="nested.disabled">{{ nested.label }}</span>
                @if (showsExternalLaunchIcon(nested)) {
                  <img src="assets/icons/launch.svg" alt="" class="tooltip-external-launch-icon" aria-hidden="true" width="14" height="14" />
                }
                @if (nested.disabled && nested.comingSoon) {
                  <span class="sidebar-coming-soon-chip">Coming Soon</span>
                }
              </span>
                </a>
              }
            </div>
          } @else {
            <a class="tooltip-subitem"
               [attr.href]="resolveHref(sub)"
               [attr.target]="anchorTarget(sub)"
               [attr.rel]="anchorRel(sub)"
               [class.active]="isSubItemActive(sub)"
               [class.disabled]="sub.disabled"
               [class.pointer-events-none]="sub.disabled && !sub.comingSoon"
               (click)="onAnchorClick($event, sub)">
              <span class="tooltip-sub-label-row">
                <span class="tooltip-sub-label" [class.disabled]="sub.disabled">{{ sub.label }}</span>
                @if (showsExternalLaunchIcon(sub)) {
                  <img src="assets/icons/launch.svg" alt="" class="tooltip-external-launch-icon" aria-hidden="true" width="14" height="14" />
                }
                @if (sub.disabled && sub.comingSoon) {
                  <span class="sidebar-coming-soon-chip">Coming Soon</span>
                }
              </span>
            </a>
          }
        }
      </div>
    </div>
  `,
  styles: [`
    .sidebar-tooltip {
      position: fixed;
      min-width: 160px;
      width: auto;
      height: auto;
      max-height: 300px;
      display: flex;
      flex-direction: column;
      z-index: 99999;
      pointer-events: auto;
      border-radius: 6px;
      border: 1px solid #EDEDED;
      background: #FFF;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.10);
      overflow: hidden;
    }

    .tooltip-submenu {
      display: flex;
      flex-direction: column;
      width: 100%;
      background: #FFF;
      border-radius: 6px;
      border: 1px solid #EDEDED;
    }

    .tooltip-subgroup {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 0.25rem 0;
    }

    .tooltip-subheading--clickable {
      cursor: pointer;
    }

    .tooltip-subheading {
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;

      &:has(.sidebar-coming-soon-chip) {
        overflow: visible;
      }
      gap: 6px;
      font-size: 12px;
      font-weight: 600;
      color: #737373;
      padding: 0.35rem 0.8rem 0.15rem 1rem;
      white-space: nowrap;

      .tooltip-subheading-label {
        flex: 1;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:has(.sidebar-coming-soon-chip) .tooltip-subheading-label {
        padding-right: calc(0.8rem + 6rem);
        transition: padding-right 0.2s ease;
      }

      .sidebar-coming-soon-chip {
        position: absolute;
        right: 0.8rem;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        opacity: 1;
        transition: opacity 0.2s ease;
        pointer-events: none;
      }

      &:hover:has(.sidebar-coming-soon-chip) .sidebar-coming-soon-chip {
        opacity: 0;
      }

      &:hover:has(.sidebar-coming-soon-chip) .tooltip-subheading-label {
        padding-right: 0;
      }

      &.disabled {
        opacity: 0.55;
      }

      &.disabled:has(.sidebar-coming-soon-chip) {
        opacity: 1;
      }

      &.disabled:has(.sidebar-coming-soon-chip) .tooltip-subheading-label {
        opacity: 0.55;
      }
    }

    .sidebar-coming-soon-chip {
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 400;
      line-height: 1;
      color: #e97b35;
      background: transparent;
      border: 1px solid #e97b35;
      border-radius: 16px;
      padding: 4px 8px;
      white-space: nowrap;
      letter-spacing: 0.02em;
    }

    .tooltip-sub-label-row {
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;

      &:has(.sidebar-coming-soon-chip) {
        overflow: visible;
      }

      .tooltip-sub-label {
        white-space: nowrap;
        min-width: 0;
      }

      &:not(:has(.sidebar-coming-soon-chip)) .tooltip-sub-label {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:has(.sidebar-coming-soon-chip) .tooltip-sub-label {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 6rem;
        transition: padding-right 0.2s ease;
      }

      .sidebar-coming-soon-chip {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        opacity: 1;
        transition: opacity 0.2s ease;
        pointer-events: none;
      }
    }

    .tooltip-subitem:hover .tooltip-sub-label-row:has(.sidebar-coming-soon-chip) .sidebar-coming-soon-chip {
      opacity: 0;
    }

    .tooltip-subitem:hover .tooltip-sub-label-row:has(.sidebar-coming-soon-chip) .tooltip-sub-label {
      padding-right: 0;
    }

    .tooltip-subitem-nested {
      padding-left: 1.25rem !important;
    }

    .tooltip-subitem {
      display: flex;
      align-items: center;
      padding: 0rem 0.8rem;
      gap: 0.2rem;
      min-width: 0;
      cursor: pointer;
      text-decoration: none;
      color: inherit;
      box-sizing: border-box;
      transition: all 0.2s ease;
      margin: 0.1rem 0.5rem;
      border-radius: 6px;

      &:hover:not(.disabled) {
        background: var(--system-background-bg-extra-weak, #FAFAFA);
      }

      &.active {
        background: #2867e0;
        margin: 0.1rem 0.5rem;

        .tooltip-sub-label {
          color: var(--common-white, #FFF);
          font-weight: 400;
        }

        .tooltip-sub-icon {
          filter: brightness(0) saturate(100%) invert(100%);
        }
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;

        .tooltip-sub-label.disabled {
          color: #999 !important;
        }

        .tooltip-sub-icon.disabled {
          opacity: 0.5;
          filter: grayscale(100%);
        }
      }

      &.disabled:has(.sidebar-coming-soon-chip) {
        opacity: 1;
        pointer-events: auto;
        cursor: not-allowed;
      }

      &.disabled:has(.sidebar-coming-soon-chip) .tooltip-sub-label.disabled {
        opacity: 0.6;
      }

      &.disabled:has(.sidebar-coming-soon-chip) .tooltip-sub-icon.disabled {
        opacity: 0.5;
        filter: grayscale(100%);
      }

      .tooltip-sub-icon-wrapper {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        .tooltip-sub-icon {
          width: 16px;
          height: 16px;
        }
      }

      .tooltip-external-launch-icon {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
        margin-left: 6px;
        object-fit: contain;
        opacity: 0.72;
      }

      &.active .tooltip-external-launch-icon {
        filter: brightness(0) saturate(100%) invert(100%);
        opacity: 1;
      }

      .tooltip-sub-label {
        font-family: var(--font-family-body-18-down, Inter);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--components-side-nav-button-default-content-default, #404040);
        white-space: nowrap;
      }
    }
  `]
})
export class SidebarTooltipComponent {
  @Input() hoveredItem: SidebarMenuItem | null = null;
  @Input() position = { left: 0, top: 0 };
  @Input() isSubItemActive: (subItem: any) => boolean = () => false;
  /** Resolves absolute URLs for real `<a href>` so link context menus work (Open in new tab, etc.). */
  @Input() resolveHref: (item: SidebarMenuItem) => string | null = () => null;

  @Output() tooltipEnter = new EventEmitter<void>();
  @Output() tooltipLeave = new EventEmitter<void>();
  @Output() navigateToSubItem = new EventEmitter<{ event: MouseEvent; subItem: SidebarMenuItem }>();

  onTooltipEnter() {
    this.tooltipEnter.emit();
  }

  onTooltipLeave() {
    this.tooltipLeave.emit();
  }

  anchorTarget(item: SidebarMenuItem): string | null {
    if (item.disabled && !item.comingSoon) {
      return null;
    }
    return item.externalTarget === '_blank' ? '_blank' : null;
  }

  anchorRel(item: SidebarMenuItem): string | null {
    return this.anchorTarget(item) === '_blank' ? 'noopener noreferrer' : null;
  }

  showsExternalLaunchIcon(item: SidebarMenuItem): boolean {
    return item.externalTarget === '_blank';
  }

  onAnchorClick(event: MouseEvent, subItem: SidebarMenuItem): void {
    if (subItem.disabled && subItem.comingSoon) {
      this.navigateToSubItem.emit({ event, subItem });
      return;
    }
    if (subItem.disabled) {
      return;
    }
    this.navigateToSubItem.emit({ event, subItem });
  }

  onSubgroupHeadingClick(sub: SidebarMenuItem): void {
    if (sub.disabled && sub.comingSoon) {
      this.navigateToSubItem.emit({ event: new MouseEvent('click'), subItem: sub });
    }
  }
}
